import {Injectable} from '@angular/core';

@Injectable()
export class ClientInvoiceGuiService {
  constructor() {
    console.log('ClientInvoiceGuiService::construct');
  }
}
